import { formatDate } from '@frontend/date';
import { useTranslation } from '@frontend/i18n';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { titleCase } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useScheduleRequestModalContext } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/Context/ScheduleRequestModalContext';
import { useScheduleRequestModalFormContext } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/Context/ScheduleRequestModalFormContext';
import { ScheduleRequestsTrackingIds } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/trackingIds';
import { Card } from './Card';
import { ContactCard } from './ContactCard';
import { ContactItem } from './ContactItem';

const ContactInfo = () => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const { personSelectorDialogProps } = useScheduleRequestModalFormContext();
  const { selectedScheduleRequest } = useScheduleRequestModalContext();
  const { schedulee } = selectedScheduleRequest;

  return (
    <>
      <div css={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: theme.spacing(2) }}>
        <ContactItem label={t('First Name')} value={schedulee?.firstName || '-'} />
        <ContactItem label={t('Last Name')} value={schedulee?.lastName || '-'} />
        <ContactItem label={t('Phone Number')} value={formatPhoneNumber(schedulee?.phoneNumber, false) || '-'} />
        <ContactItem label={t('Email')} value={schedulee?.email || '-'} />
        <ContactItem label={t('Date of Birth')} value={formatDate(schedulee?.birthDate, 'MM/DD/YYYY') || '-'} />
        <ContactItem label={t('Gender')} value={(schedulee?.gender && titleCase(schedulee?.gender)) || '-'} />
      </div>
      <Button
        css={{ marginTop: theme.spacing(2) }}
        size='large'
        iconName='link'
        trackingId={ScheduleRequestsTrackingIds.linkPatientButton}
        {...personSelectorDialogProps.getTriggerProps()}
      >
        {t('Link Patient')}
      </Button>
    </>
  );
};

export const PatientInfoCard = () => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const { selectedPerson } = useScheduleRequestModalFormContext();

  return <Card title={t('Contact Information')}>{selectedPerson ? <ContactCard /> : <ContactInfo />}</Card>;
};
